export enum Theme {
  LIGHT = "light",
  DARK = "dark",
  AQUA_MAGENTA = "aqua-magenta"
}